<template>
  <b-modal no-fade v-model="dialog.show" size="lg"  :id="`modal-pixel-${uniqueId}`"
           :hide-footer="true" centered @close="onDialogClose"
           no-close-on-backdrop
  >
    <template #modal-title>
     <span v-if="loading !== true && error == null && pixel != null && pixel.id != null">
       {{ pixel.email }}
     </span>
    </template>
    <div style="min-height: 600px">
      <div v-if="loading !== true && error == null">
        <pixel-edit-details v-bind:new-pixel="isNewPixel" v-model="pixel" @close="closeModal" />
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else-if="loading !== true && error != null">
        <b-alert show variant="danger" >
          <i class="fa-sharp fa-solid fa-triangle-exclamation"></i>
          {{ error }}
        </b-alert>
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else>
        <b-spinner>{{$t('operations.loading')}}</b-spinner>
      </div>
    </div>
  </b-modal>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import { mapActions } from 'vuex'
import PixelEditDetails from '@/components/partial/campaigns/PixelEditDetails'
import Pixel from '@/model/campaign/Pixel'

export default {
  name: 'pixelModal',
  components: { PixelEditDetails },
  mixins: [mixinBase, mixinNotifications],
  data: () => ({
    dialog: {
      show: false,
    },
    uniqueId: 0,
    loading: true,
    error: null,
    id: null,
    isNewPixel: false,
    pixel: {}
  }),
  watch: {
    queryParams:{
      handler(){
        if(this.queryParams().pixelId == null) {
          this.closeModal()
          return
        }
        if (this.queryParams().pixelId !== this.id) {
          this.showModal(this.queryParams().pixelId)
        }
      },
      deep: true
    }
  },
  created() {
    this.uniqueId = this._uid
    if(this.queryParams().pixelId != null) {
      this.showModal(this.queryParams().pixelId)
    }
  },
  methods: {
    ...mapActions('pixel', ['getPixelById']),
    showModal(id) {
      this.id = id
      this.loading = true
      this.dialog.show = true
      this.dialog.tab = 0
      this.isNewPixel = this.id == null || this.id === 0;
      if(!this.isNewPixel) {
        this.refreshData()
      }else {
        this.pixel = Pixel()
        this.error = null
        this.loading = false
      }
      this.pushState({pixelId: id, tab: 0, })
    },
    closeModal(){
      this.dialog.show = false;
      this.pixel = {}
      this.onDialogClose()
    },
    onDialogClose(){
      this.id = null;
      this.pushState({pixelId: null, tab: null, })
    },
    refreshData() {
      let $this = this;
      this.getPixelById(this.id)
          .then(pixel => {
            $this.pixel = pixel;
            $this.error = null
            $this.loading = false
          }, err => {
            $this.error = $this.getErrorDescription(err)
            $this.loading = false
          })
    },
  }
}
</script>

<style scoped>

</style>
